import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { API_URL } from '../../config/apiEndpoints';
import Moment from "react-moment";
import 'moment/locale/ro';
import { Link } from 'react-router-dom';
import { slugify } from '../../helpers/general.helper';
import Favorite from '../favorite/favorite.component';
import Parser from 'html-react-parser';

class MovieListItem extends Component {

    render() {
        return (
            <Fragment>
                <div className="col-2 image-holder">
                    <Link to={`/film/${this.props.card.film_id}/${slugify(this.props.card.film_title)}`} className="white-text">
                        <img alt={'Film'} src={API_URL + Parser(this.props.card.film_poster)} />
                    </Link>
                </div>
                <div className="col-10 list-view">
                    <div className="movie-item-list-view">
                        <div className="col-12 title-holder">
                            <span className="title-item">
                                <Link to={`/film/${this.props.card.film_id}/${slugify(this.props.card.film_title)}`} className="white-text">
                                    {Parser(this.props.card.film_translated_title) || Parser(this.props.card.film_title)}
                                </Link>
                                <span className="year-item">({this.props.card.film_release_year})</span>
                            </span>

                        </div>

                        <div className="col-12 romanian-translation-title">
                            <span>{Parser(this.props.card.film_title)}</span>
                        </div>

                        <div className="col-12 imdb">
                            <span className="imdb-icon" />
                            <span className="grade">{this.props.card.film_rating_imdb}</span>
                            <span className="star-icon" />
                        </div>

                        <div className="col-12 movie-dtls">
                            <span className="preview">{this.props.card.film_status}</span>
                        </div>

                        <div className="col-12 additional-details-list">
                            <span className="other-details dark-grey-text">
                                {this.props.card.film_age_restrictions} | {this.props.card.film_duration} | {this.props.card.film_genre} | {this.props.film_projection_formats}
                            </span>
                            <span className="other-details light-grey-text">
                                Premiera <Moment format="DD MMMM YYYY" locale="ro" unix>
                                    {this.props.card.film_release_date}
                                </Moment>
                            </span>
                            <span className="other-details dark-grey-text">Director: {this.props.card.film_director}</span>
                            <span className="other-details light-grey-text">Writers: {this.props.card.film_scenarist}</span>
                            <span className="other-details dark-grey-text">Stars: {this.props.card.film_cast_short}</span>
                        </div>
                        <Favorite
                            favorite={this.props.card.favorite}
                            component="list"
                            type={this.props.component}
                            id={this.props.card.film_uuid}
                        />
                    </div>
                </div>
                <div className="col-12 end-line"></div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(MovieListItem);





// WEBPACK FOOTER //
// ./src/SHARED/components/movielistitem/movielistitem.component.js